import type { FC } from 'react'
import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import MultichannelMessagingImage from './MultichannelMessagingImage'

const copy = {
  heading: `Native multichannel messaging`,
  description: `Orchestrate WhatsApp, SMS and email campaigns seamlessly throughout journeys to engage customers across the entire customer lifecycle.`,
}

const boxes = [
  {
    headline: `Efficient campaign creation`,
    content: `An intuitive campaign builder allows marketers to create and efficiently launch WhatsApp campaigns throughout the customer journey.`,
  },
  {
    headline: `Understand, iterate and improve campaign performance`,
    content: `Experiment with A/B testing and leverage Journey Analytics to understand WhatsApp channel performance and optimize your multichannel strategy.`,
  },
  {
    headline: `Optimize communications and spend`,
    content: `Use real-time data to personalize a customer's multichannel journey to deliver a more relevant customer experience and optimize budget by halting ads or WhatsApp messages the moment a customer takes action.`,
  },
]

const MultichannelMessaging: FC = () => {
  return (
    <SectionBase variant="2Col">
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>
        <ColumnTrackWrapper>
          <ColumnTrack gap="medium">
            {boxes.map(({ headline, content }) => (
              <FeatureBoxBase alignment="left" key={headline}>
                <FeatureBox.Body>
                  <FeatureBox.Title>{headline}</FeatureBox.Title>
                  <FeatureBox.Text>{content}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </ColumnTrackWrapper>
      </SectionCopy>
      <Section.Contents>
        <MultichannelMessagingImage />
      </Section.Contents>
    </SectionBase>
  )
}

export default MultichannelMessaging

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

const SectionCopy = styled(Section.Copy)`
  max-width: 440px;
`
